import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';


const routes: Routes = [
  {
    path: '', redirectTo: 'menu', pathMatch: 'full'
  },

  {
    path: 'menu',
    loadChildren: () => import('./pages/menu/menu.module').then(m => m.MenuPageModule)
  },
  {
    path: 'orderfood',
    loadChildren: () => import('./pages/orderfood/orderfood.module').then(m => m.OrderfoodPageModule)
  },
  {
    path: 'viewbooking',
    loadChildren: () => import('./pages/admin/viewbooking/viewbooking.module').then(m => m.ViewbookingPageModule)
  },
  {
    path: 'bookingprofile',
    loadChildren: () => import('./pages/admin/bookingprofile/bookingprofile.module').then(m => m.BookingprofilePageModule)
  },
  {
    path: 'allhotels',
    loadChildren: () => import('./pages/admin/allhotels/allhotels.module').then(m => m.AllhotelsPageModule)
  },
  {
    path: 'updatehotel',
    loadChildren: () => import('./pages/admin/updatehotel/updatehotel.module').then(m => m.UpdatehotelPageModule)
  },
  {
    path: 'filtermodal',
    loadChildren: () => import('./pages/modal/filtermodal/filtermodal.module').then(m => m.FiltermodalPageModule)
  },
  {
    path: 'editpassword',
    loadChildren: () => import('./pages/modal/editpassword/editpassword.module').then(m => m.EditpasswordPageModule)
  },
  {
    path: 'footer',
    loadChildren: () => import('./pages/_shared/footer/footer.module').then(m => m.FooterPageModule)
  },
  {
    path: 'search',
    loadChildren: () => import('./pages/modal/search-modal/search-modal.module').then(m => m.SearchModalPageModule)
  },




];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
